import { Button } from '@mui/material';
import { string } from 'prop-types';
import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { I18n } from 'utils/i18n';
import editEmployeeDrawer from 'store/app/ui/drawers/employee/action';
import { useCanManageEmployees } from 'utils/useCanManageEmployees';

const EditProfileButton = ({ employeeId }) => {
  const canManageEmployees = useCanManageEmployees();

  const dispatch = useDispatch();
  const edit = useCallback(() => {
    dispatch(editEmployeeDrawer.open(employeeId));
  }, [dispatch, employeeId]);

  if (!canManageEmployees) {
    return null;
  }

  return (
    <Button onClick={edit} variant="contained" color="primary">
      {I18n.t('ProfileDrawer.Edit profile')}
    </Button>
  );
};

EditProfileButton.propTypes = {
  employeeId: string.isRequired,
};

export default memo(EditProfileButton);
